import { motion } from 'framer-motion';
import { engineerTimeline, violinistTimeline } from '../../../data/profile';
import TimelineColumn from './TimelineColumn';
import './about.scss';

export default function About() {
  return (
    <section className="about" id="about">
      <div className="about__header">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="about__eyebrow"
        >
          About
        </motion.div>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.25, 1, 0.5, 1] }}
          className="about__title"
        >
          Two strings, one signal.
        </motion.h2>
      </div>
      <div className="about__columns">
        <TimelineColumn data={engineerTimeline} />
        <div className="about__divider" aria-hidden />
        <TimelineColumn data={violinistTimeline} />
      </div>
    </section>
  );
}
